export const actionType = {
  HEADCOUNTTREND: 'HEADCOUNTTREND',
  HEADCOUNT_ACTIVE_EMPLOYEE_CSV: 'HEADCOUNT_ACTIVE_EMPLOYEE_CSV',
  HEADCOUNT_TURNOVER_BREAKDOWN_CSV: 'HEADCOUNT_TURNOVER_BREAKDOWN_CSV',
  HEADCOUNT_TOTAL_EMPLOYEE: 'HEADCOUNT_TOTAL_EMPLOYEE',
  HEADCOUNT_NEWJOINER: 'HEADCOUNT_NEWJOINER',
  HEADCOUNT_NEWJOINER_CSV: 'HEADCOUNT_NEWJOINER_CSV',
  HEADCOUNT_LEAVING: 'HEADCOUNT_LEAVING',
  HEADCOUNT_LEAVING_EMPLOYEE_CSV: 'HEADCOUNT_LEAVING_EMPLOYEE_CSV',
  HEADCOUNT_TURNOVER: 'HEADCOUNT_TURNOVER',
  HEADCOUNT_ORGANIZATION: 'HEADCOUNT_ORGANIZATION',
  HEADCOUNT_JOBLEVEL: 'HEADCOUNT_JOBLEVEL',
  HEADCOUNT_BREAKDOWN: 'HEADCOUNT_BREAKDOWN',
  HEADCOUNT_EMPLOYEE_TRANSFER: 'HEADCOUNT_EMPLOYEE_TRANSFER',
  HEADCOUNT_EMPLOYEE_TRANSFER_CSV: 'HEADCOUNT_EMPLOYEE_TRANSFER_CSV',
  HEADCOUNT_BREAKDOWN_BRANCH_CSV: 'HEADCOUNT_BREAKDOWN_BRANCH_CSV',
  HEADCOUNT_BREAKDOWN_ORGANIZATION_CSV: 'HEADCOUNT_BREAKDOWN_ORGANIZATION_CSV',
  HEADCOUNT_BREAKDOWN_JOB_LEVEL_CSV: 'HEADCOUNT_BREAKDOWN_JOB_LEVEL_CSV',
  HEADCOUNT_BREAKDOWN_GRADE_CSV: 'HEADCOUNT_BREAKDOWN_GRADE_CSV',
  HEADCOUNT_BREAKDOWN_EMPLOYMENT_STATUS_CSV: 'HEADCOUNT_BREAKDOWN_EMPLOYMENT_STATUS_CSV',
  HEADCOUNT_BREAKDOWN_GENDER_CSV: 'HEADCOUNT_BREAKDOWN_GENDER_CSV',
  HEADCOUNT_BREAKDOWN_AGE_CSV: 'HEADCOUNT_BREAKDOWN_AGE_CSV',
  HEADCOUNT_BREAKDOWN_LATEST_EDUCATION_CSV: 'HEADCOUNT_BREAKDOWN_LATEST_EDUCATION_CSV',
  HEADCOUNT_BREAKDOWN_RELIGION_CSV: 'HEADCOUNT_BREAKDOWN_RELIGION_CSV',
  HEADCOUNT_BREAKDOWN_PTKP_STATUS_CSV: 'HEADCOUNT_BREAKDOWN_PTKP_STATUS_CSV',
  HEADCOUNT_SERVICE_LENGTH: 'HEADCOUNT_SERVICE_LENGTH',
  HEADCOUNT_SERVICE_LENGTH_CSV: 'HEADCOUNT_SERVICE_LENGTH_CSV',
  HEADCOUNT_REACHING_TENURE_1: 'HEADCOUNT_REACHING_TENURE_1',
  HEADCOUNT_REACHING_TENURE_3: 'HEADCOUNT_REACHING_TENURE_3',
  HEADCOUNT_REACHING_TENURE_5: 'HEADCOUNT_REACHING_TENURE_5',
  HEADCOUNT_RESIGN_JOIN: 'HEADCOUNT_RESIGN_JOIN',
  HEADCOUNT_RESIGN_JOIN_CSV: 'HEADCOUNT_RESIGN_JOIN_CSV',
  HEADCOUNT_HR_RATIO: 'HEADCOUNT_HR_RATIO',
  HEADCOUNT_TURNOVER_GENDER: 'HEADCOUNT_TURNOVER_GENDER',
  HEADCOUNT_TURNOVER_EDUCATION: 'HEADCOUNT_TURNOVER_EDUCATION',
  HEADCOUNT_TURNOVER_AGE: 'HEADCOUNT_TURNOVER_AGE',
  HEADCOUNT_TURNOVER_VOLUNTARY: 'HEADCOUNT_TURNOVER_VOLUNTARY',
  HEADCOUNT_TURNOVER_WORKS_PERIOD: 'HEADCOUNT_TURNOVER_WORKS_PERIOD',
  HEADCOUNT_RESIGN_REASON: 'HEADCOUNT_RESIGN_REASON',
  HEADCOUNT_RESIGN_REASON_CSV: 'HEADCOUNT_RESIGN_REASON_CSV',
  HEADCOUNT_REPRIMAND_TYPES: 'HEADCOUNT_REPRIMAND_TYPES',
  HEADCOUNT_REPRIMAND_HISTORY: 'HEADCOUNT_REPRIMAND_HISTORY',
  HEADCOUNT_REPRIMANDTREND_CSV: 'HEADCOUNT_REPRIMAND_TREND_CSV',
  // attendance
  ATTENDANCE_RECORDS: 'ATTENDANCE_RECORDS',
  API_ATTENDANCE_TIMEOFF_POLICIES: 'API_ATTENDANCE_TIMEOFF_POLICIES',
  API_ATTENDANCE_TIMEOFF: 'ATTENDANCE_TIMEOFF',
  ATTENDANCE_TIMEOFF_MODAL: 'ATTENDANCE_TIMEOFF_MODAL',
  EMPLOYEE_ATTENDANCE: 'EMPLOYE_ATTENDANCE',
  EMPLOYEE_ATTENDANCE_MODAL: 'EMPLOYEE_ATTENDANCE_MODAL',
  ATTENDANCE_TIMEOFF_TRENDS: 'ATTENDANCE_TIMEOFF_TRENDS',
  ATTENDANCE_METRICS: 'ATTENDANCE_METRICS',
  ATTENDANCE_METRICS_TYPE: 'ATTENDANCE_METRICS_TYPE',
  // survey / company
  ATTENDANCE_ORGANIZATION: 'ATTENDANCE_ORGANIZATION',
  ATTENDANCE_BRANCHES: 'ATTENDANCE_BRANCHES',
  JOB_POSITION: 'JOB_POSITION',
  // Attritions
  ATTRITIONS_OVERVIEW: 'ATTRITIONS_OVERVIEW',
  ATTRITIONS_OVERVIEW_BY_FILTER: 'ATTRITIONS_OVERVIEW_BY_FILTER',
  ATTRITIONS_OVERVIEW_BY_EMPLOYEE: 'ATTRITIONS_OVERVIEW_BY_EMPLOYEE',
  // Global
  CNAME: 'CNAME',
  LAST_UPDATE: 'LAST_UPDATE',
  SHOW_SURVEY: 'SHOW_SURVEY',
  ERROR_STATUS: 'ERROR_STATUS',
  BRANCH_FILTER: 'BRANCH_FILTER',
  ORGANIZATION_FILTER: 'ORGANIZATION_FILTER',
  JOB_POSITION_FILTER: 'JOB_POSITION_FILTER',
  JOB_POSITION_MODAL_FILTER: 'JOB_POSITION_MODAL_FILTER',
  // Auth Current User Company
  CURRENT_USER: 'CURRENT_USER',
  CHECK_AUTH: 'CHECK_AUTH',
  REPORT_BUILDER_AUTH: 'REPORT_BUILDER_AUTH',
  SIGN_OUT: 'SIGN_OUT',
  EXPORT_HISTORY: 'EXPORT_HISTORY'
};
